module.exports = __webpack_public_path__ + "img/Butterfly_00006.747eb985.png";